
import axios from '../config/axios';

export const url = '/api/imagenesdeinmuebles087wq'


export const customlistadodeimagenesdeinmuebleu092u_67c86a7fa9c8dc86c6729880 = ({
  inmueblep8cx5,

}) => new Promise((resolve, reject) => {
  if (true) {
    axios.get(`${url}/custom/listado`, {
      params: {
        inmueblep8cx5,

      },
      
    }).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});



